import React, { useEffect, useMemo } from "react"
import Users from "./Users"
// import UserRole from "./UserRole"
// import Roles from "./Roles"
import { Permissions } from "config/constants"
import { useAbac } from "react-abac"
import { Divider, Segmented } from "antd-v5"
import useFeatureFlags from "hooks/useFeatureFlags"
import { FeatureFlagEnums } from "types/featureFlags.type"
import { useAdminQueryParams } from "hooks"
import { AdminSecurityOptions, SECURITY_TABS } from "types/security.types"
// import { IS_SUPER_ADMIN, Permissions } from "config/constants"
// import ResourceAccess from "./ResourceAccess"

const Index = () => {
	const { userHasPermissions } = useAbac()
	const { featureFlagEnabled } = useFeatureFlags()
	const { params, setSearchParams } = useAdminQueryParams()
	const { tab } = params
	const options: AdminSecurityOptions[] = useMemo(() => {
		return [
			{
				label: "Users",
				perform: Permissions.VIEW_ADMIN_SECURITY,
				featureName: FeatureFlagEnums.ADMIN_SECURITY_USERS,
				component: <Users />,
				value: SECURITY_TABS.USERS,
			},
			// {
			// 	label: "User Roles",
			// 	perform: Permissions.VIEW_ADMIN_SECURITY,
			// 	component: <Roles/>,
			// },
			// {
			// 	label: "Resource Access",
			// 	perform: IS_SUPER_ADMIN,
			// 	component: <ResourceAccess/>,
			// },
		]
			.map(item => ({ ...item, value: item.value }))
			.filter(item => userHasPermissions(item.perform) && featureFlagEnabled(item.featureName))
	}, [])

	const doesTabExist = useMemo(() => options.some(({ value }) => value === tab), [options, tab])

	useEffect(() => {
		setSearchParams({ tab: tab || options[0]?.value })
	}, [options, tab])

	const component = useMemo(() => {
		return options?.find(item => item.value === (tab || options[0]?.value))?.component
	}, [options, tab])

	return (
		<div>
			<Divider style={{ margin: "8px", marginLeft: "0px", marginRight: "0px" }} />
			<div className="flex items-center justify-start">
				<Segmented
					options={options}
					value={doesTabExist ? tab : options[0]?.value}
					onChange={value => setSearchParams({ tab: value as string, selected: "" })}
				/>
			</div>
			<Divider style={{ margin: "8px", marginLeft: "0px", marginRight: "0px" }} />
			{component && <div className="px-2">{component}</div>}
		</div>
	)
}

export default Index
